import { apiGet, apiPost, hasApiAuthToken } from '@/services/api-client';

export type EditorPresencePeer = {
  userId: string;
  username: string;
  name: string;
  tabId: string;
};

type PresenceResponse = {
  data: {
    editors: EditorPresencePeer[];
  };
};

export async function fetchEditorPresence(
  resource: string,
  tabId: string
): Promise<EditorPresencePeer[]> {
  if (!hasApiAuthToken()) return [];
  try {
    const res = await apiGet<PresenceResponse>(
      `/admin/presence?resource=${encodeURIComponent(resource)}&tabId=${encodeURIComponent(tabId)}`,
      true
    );
    return res.data?.editors ?? [];
  } catch {
    return [];
  }
}

export async function heartbeatEditorPresence(
  resource: string,
  tabId: string,
  label?: string
): Promise<EditorPresencePeer[]> {
  if (!hasApiAuthToken()) return [];
  try {
    const res = await apiPost<PresenceResponse>(
      '/admin/presence/heartbeat',
      { resource, tabId, label },
      true
    );
    return res.data?.editors ?? [];
  } catch {
    return [];
  }
}

export async function leaveEditorPresence(resource: string, tabId: string): Promise<void> {
  if (!hasApiAuthToken()) return;
  try {
    await apiPost('/admin/presence/leave', { resource, tabId }, true);
  } catch {
    /* ignore */
  }
}
